import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './SubmittalCard.css';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import moment from 'moment';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import TextareaAutosize from 'react-autosize-textarea';
import SearchableDropDownPaginated from 'components/shared/dropdown/SearchableDropDownPaginated';
import MultipleDropdown from 'components/shared/dropdown/MultipleDropdown';
import {
  todayValidation,
  beforeTodayValidation,
} from 'services/utils/date-util';
import { countdown } from 'services/utils/date-util';
import { usersUtil, ROLES } from 'services/utils/users-util';
import { Enterprise } from 'domain/enterprise';
import { Project } from 'domain/project';
import { Submittal } from 'domain/submittal';
import { SubmittalStatusEnum } from 'domain/submittal-status-enum';
import { getDirectory } from 'components/admin/projects/details/project-directory/store/selectors';
import {
  getSubmittalForm,
  getSubmittalReadOnly,
  getSubmittalGcAcceleration,
} from 'components/admin/projects/details/project-submittal-log/store/selectors';
import { searchDirectory } from 'components/admin/projects/details/project-directory/store/actions';
import {
  updateSubmittalFormValue,
  deleteSubmittalFile,
  markSubmittalNotesRead,
} from 'components/admin/projects/details/project-submittal-log/store/actions';
import SubmittalDocuments from 'components/admin/projects/details/project-submittal-log/SubmittalDocuments';
import SubmittalAddlAssignees from 'components/admin/projects/details/project-submittal-log/SubmittalAddlAssignees';

class SubmittalCard extends Component {
  static propTypes = {
    currentUser: PropTypes.shape({}).isRequired,
    project: PropTypes.shape({}).isRequired,
    submittal: PropTypes.shape({}),
  };

  componentDidMount() {
    this.handleMarkSubmittalNotesRead();
  }

  loadContributors = () => {
    const { project, dispatch } = this.props;
    let users = {};
    return dispatch(searchDirectory(project.id)).then((response) => {
      if (response.ok) {
        const contributors = response.directory.project_contributors
          .filter((pc) => pc.primary && pc.company_type !== 'GeneralContractor')
          .map((pc) => {
            return pc.users
              .filter((usr) => !users[usr.id])
              .map((usr) => {
                users[usr.id] = true;
                return {
                  value: usr.id,
                  label: Project.userLabelStr(usr, pc.company),
                };
              });
          })
          .reduce((acc, val) => acc.concat(val), []);

        return {
          ok: true,
          options: contributors,
        };
      }
    });
  };

  recipientOptions = () => {
    return Project.recipientOptions(this.props);
  };

  handleFormChange = (attribute, value) => {
    this.props.dispatch(updateSubmittalFormValue(attribute, value));
  };

  handleFormDeleteFile = (attribute, value) => {
    this.props.dispatch(deleteSubmittalFile(attribute, value));
  };

  handleMarkSubmittalNotesRead = () => {
    const { currentUser, form, dispatch } = this.props;
    if (form.id) {
      dispatch(markSubmittalNotesRead(form.id, form, currentUser.id));
    }
  };

  render() {
    const {
      currentUser,
      project,
      submittal,
      form,
      readOnly,
      gcAcceleration,
    } = this.props;
    const spackleOrGc =
      Enterprise.spackleOrGc(project.contributor_type) &&
      !usersUtil.hasRole(currentUser, ROLES.GENERAL_CONTRACTOR_SUPERINTENDENT);
    const requestReadOnly =
      readOnly || Enterprise.primary(project.contributor_type);
    const assignedToCurrentUser =
      submittal && Submittal.assignee(submittal, currentUser);
    const addlAssignee =
      submittal && Submittal.addlAssignee(submittal, currentUser);
    const assignee = submittal && submittal.assignee;
    const today = moment();
    let requestedDateCountdown =
      form && form.requestedDate
        ? countdown(today.format('YYYY-MM-DD'), form.requestedDate)
        : null;
    if (requestedDateCountdown) {
      requestedDateCountdown += ' ago';
    }
    let dueDateCountdown =
      form && form.dueDate
        ? countdown(today.format('YYYY-MM-DD'), form.dueDate)
        : null;
    let extendedDueDateCountdown =
      form && form.extendedDueDate
        ? countdown(today.format('YYYY-MM-DD'), form.extendedDueDate)
        : null;
    if (dueDateCountdown) {
      dueDateCountdown += today > moment(form.dueDate) ? ' past due' : ' left';
    }
    if (extendedDueDateCountdown) {
      extendedDueDateCountdown +=
        today > moment(form.extendedDueDate) ? ' past due' : ' left';
    }

    return (
      <div className="submittal-card">
        <Form horizontal>
          {(requestReadOnly || spackleOrGc) && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                {readOnly ? 'Assigned To' : 'Assign To'}
              </Col>
              <Col sm={8}>
                {form.assignee.length === 0 ? (
                  readOnly ? (
                    <span className="read-only">-</span>
                  ) : (
                    <SearchableDropDownPaginated
                      loadOptions={this.loadContributors}
                      onChange={(option) => {
                        this.handleFormChange('assignee', [
                          option.value,
                          option.label,
                        ]);
                        this.handleFormChange(
                          'status',
                          SubmittalStatusEnum.ASSIGNED.status
                        );
                      }}
                      placeholder="Add Contributor"
                    />
                  )
                ) : (
                  <div
                    className="contributor-selected"
                    onClick={() => {
                      if (!readOnly && spackleOrGc) {
                        this.handleFormChange('assignee', []);
                        this.handleFormChange(
                          'status',
                          SubmittalStatusEnum.PENDING.status
                        );
                      }
                    }}
                  >
                    {!readOnly && spackleOrGc && (
                      <span className="remove">X</span>
                    )}
                    <span>{form.assignee[1]}</span>
                  </div>
                )}
              </Col>
            </FormGroup>
          )}
          {spackleOrGc && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                Requested Date
              </Col>
              <Col
                sm={requestReadOnly ? 8 : 4}
                className={requestReadOnly ? 'read-only' : ''}
              >
                {requestReadOnly ? (
                  <span>
                    {form.requestedDate
                      ? moment(form.requestedDate).format('M/D/YY')
                      : '-'}
                    {!form.closed && requestedDateCountdown && (
                      <span>, {requestedDateCountdown}</span>
                    )}
                  </span>
                ) : (
                  <DatetimePicker
                    isValidDate={beforeTodayValidation}
                    placeholder="Choose Date..."
                    value={form.requestedDate}
                    onChange={(value) =>
                      this.handleFormChange('requestedDate', value)
                    }
                  />
                )}
              </Col>
              {!requestReadOnly && !form.closed && requestedDateCountdown && (
                <Col componentClass={ControlLabel} sm={4} className="countdown">
                  {requestedDateCountdown}
                </Col>
              )}
            </FormGroup>
          )}
          <FormGroup>
            <Col componentClass={ControlLabel} sm={1}>
              Due Date
            </Col>
            <Col
              sm={requestReadOnly ? 8 : 4}
              className={requestReadOnly ? 'read-only' : ''}
            >
              {requestReadOnly ? (
                <span>
                  {form.dueDate ? moment(form.dueDate).format('M/D/YY') : '-'}
                  {!form.closed && dueDateCountdown && (
                    <span>, {dueDateCountdown}</span>
                  )}
                </span>
              ) : (
                <div
                  className={classnames({ 'form-error': form.errors.dueDate })}
                >
                  <DatetimePicker
                    isValidDate={todayValidation}
                    placeholder="Choose Date..."
                    value={form.dueDate}
                    onChange={(value) =>
                      this.handleFormChange('dueDate', value)
                    }
                  />
                </div>
              )}
            </Col>
            {!requestReadOnly && !form.closed && dueDateCountdown && (
              <Col componentClass={ControlLabel} sm={4} className="countdown">
                {dueDateCountdown}
              </Col>
            )}
          </FormGroup>
          {assignee && (!requestReadOnly || form.extendedDueDate) && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                Extended Due Date
              </Col>
              <Col
                sm={requestReadOnly ? 8 : 4}
                className={requestReadOnly ? 'read-only' : ''}
              >
                {requestReadOnly ? (
                  <span>
                    {moment(form.extendedDueDate).format('M/D/YY')}
                    {!form.closed && extendedDueDateCountdown && (
                      <span>, {extendedDueDateCountdown}</span>
                    )}
                  </span>
                ) : (
                  <div
                    className={classnames({
                      'form-error': form.errors.extendedDueDate,
                    })}
                  >
                    <DatetimePicker
                      isValidDate={todayValidation}
                      placeholder="Choose Date..."
                      value={form.extendedDueDate}
                      onChange={(value) =>
                        this.handleFormChange('extendedDueDate', value)
                      }
                    />
                  </div>
                )}
              </Col>
              {!requestReadOnly && !form.closed && extendedDueDateCountdown && (
                <Col componentClass={ControlLabel} sm={4} className="countdown">
                  {extendedDueDateCountdown}
                </Col>
              )}
            </FormGroup>
          )}
          {(requestReadOnly || spackleOrGc) && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                Additional Assignees
              </Col>
              <Col sm={form.id ? 8 : 4}>
                <SubmittalAddlAssignees project={project} />
              </Col>
            </FormGroup>
          )}
          {spackleOrGc && (
            <FormGroup>
              <Col componentClass={ControlLabel} sm={1}>
                CC Recipient(s)
              </Col>
              <Col sm={8} className={requestReadOnly ? 'text-read-only' : ''}>
                {requestReadOnly ? (
                  form.recipients.length === 0 ? (
                    '-'
                  ) : (
                    form.recipients.map((rcpt) => rcpt[1]).join(', ')
                  )
                ) : (
                  <MultipleDropdown
                    options={this.recipientOptions()}
                    currentValues={form.recipients}
                    placeholder="Select Contributors to CC"
                    onChange={(values) =>
                      this.handleFormChange('recipients', values)
                    }
                  />
                )}
              </Col>
            </FormGroup>
          )}
          <FormGroup>
            <Col componentClass={ControlLabel} sm={1}>
              Submittal Request
            </Col>
            <Col sm={8} className={requestReadOnly ? 'text-read-only' : ''}>
              {requestReadOnly ? (
                form.question ? (
                  <span className="read-only-question">{form.question}</span>
                ) : (
                  '-'
                )
              ) : (
                <TextareaAutosize
                  className={classnames({ 'form-error': form.errors.question })}
                  rows={1}
                  placeholder="Enter Text Here..."
                  defaultValue={form.question}
                  onBlur={(e) =>
                    this.handleFormChange('question', e.target.value)
                  }
                />
              )}
            </Col>
          </FormGroup>
          <SubmittalDocuments
            submittal={submittal}
            form={form}
            fileType="req"
            handleFormChange={this.handleFormChange}
            handleFormDeleteFile={this.handleFormDeleteFile}
            readOnly={requestReadOnly}
          />
          {(gcAcceleration || readOnly || assignedToCurrentUser) && (
            <div className="submittal-response">
              {(readOnly || !addlAssignee) && (
                <FormGroup>
                  <Col componentClass={ControlLabel} sm={1}>
                    Remarks
                  </Col>
                  <Col sm={8} className={readOnly ? 'text-read-only' : ''}>
                    {readOnly ? (
                      form.remarks ? (
                        <span className="read-only-question">
                          {form.remarks}
                        </span>
                      ) : (
                        '-'
                      )
                    ) : (
                      <TextareaAutosize
                        rows={1}
                        placeholder="Enter Text Here..."
                        defaultValue={form.remarks}
                        onBlur={(e) =>
                          this.handleFormChange('remarks', e.target.value)
                        }
                      />
                    )}
                  </Col>
                </FormGroup>
              )}
              <SubmittalDocuments
                currentUser={currentUser}
                submittal={submittal}
                submittalAddlAssignee={addlAssignee}
                form={form}
                fileType="res"
                handleFormChange={this.handleFormChange}
                handleFormDeleteFile={this.handleFormDeleteFile}
                readOnly={readOnly}
              />
            </div>
          )}
        </Form>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    directory: getDirectory(state),
    form: getSubmittalForm(state),
    readOnly: getSubmittalReadOnly(state),
    gcAcceleration: getSubmittalGcAcceleration(state),
  };
})(SubmittalCard);



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-submittal-log/SubmittalCard.js